import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { Outlet } from 'react-router';

import BottomBar from './BottomBar/BottomBar';
import BaseDrawer from './drawer/BaseDrawer';

const LayoutBase = () => {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));
  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      sx={{
        minHeight: '100vh, -webkit-fill-available',
        height: isMobile ? '100dvh' : 'auto',
        maxHeight: '100dvh',
      }}
    >
      {!isMobile ? <BaseDrawer /> : null}
      <NuqsAdapter>
        <Outlet />
      </NuqsAdapter>
      {isMobile ? <BottomBar /> : null}
    </Stack>
  );
};

export default LayoutBase;
